import React from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";

/**
 * SortErrorModal Component
 * 
 * Error notification modal displayed when sort operation fails. Provides helpful
 * error message with support contact link for further assistance.
 * 
 * @returns {JSX.Element} Error notification with troubleshooting suggestions
 */
const SortErrorModal = () => {
  return (
    <div style={{ paddingTop: "10px" }}>
      <p style={{ color: "red" }}>
        <AiOutlineCloseCircle className="alert-icon" /> Error
      </p>
      <p style={{ marginLeft: "28px" }}>
        There seems to be an issue and we couldn't sort your selected column(s).
        Please try again.
      </p>
      <p style={{ marginLeft: "28px" }}>
        If you still have trouble sorting your selected column(s), please{" "}
        <a href="https://www.roiquant.com/contact">contact our support team</a>{" "}
        for help.
      </p>
    </div>
  );
};

export default SortErrorModal;
